<template>
    <div class="landing-page-template-container">
        <div class="join-us-modal-container" v-show="showJoinUs">
            <div class="join-us-modal">
                <div class="join-us-close" @click="toggleJoinUs()"><span class="icon"><img src="/Assets/img/cancel.svg" /></span></div>
                <div class="join-us-sections">
                    <div class="join-us-section-header">
                        Join {{settings.siteNameCaps}}
                    </div>
                    <a class="join-us-section" :href="whatsappLink ? whatsappLink : settings.socialLinks.whatsapp" target="_blank" @click="trackEvent('whatsapp')" v-if="whatsapp">
                        <div class="join-us-icon"><img src="/assets/img/logo-whatsapp.png"></div>
                        <div class="join-us-text">JOIN OUR WHATAPP GROUP</div>
                    </a>
                    <a class="join-us-section" :href="settings.socialLinks.facebook" target="_blank" @click="trackEvent('facebook')" v-if="facebook">
                        <div class="join-us-icon"><img src="/assets/img/logo-facebook.jpg"></div>
                        <div class="join-us-text">JOIN US ON FACEBOOK</div>
                    </a>
                    <a class="join-us-section" @click="openNewsletterModal()" v-if="email">
                        <div class="join-us-icon"><img src="/assets/img/daily-deals.png"></div>
                        <div class="join-us-text">DAILY DEALS EMAIL</div>
                    </a>
                    <a class="join-us-section" :href="settings.socialLinks.instagram" target="_blank" @click="trackEvent('instagram')" v-if="instagram">
                        <div class="join-us-icon"><img src="/assets/img/logo-instagram.jpg"></div>
                        <div class="join-us-text">FOLLOW US ON INSTAGRAM</div>
                    </a>
                    <a class="join-us-section" :href="settings.socialLinks.twitter" target="_blank" @click="trackEvent('twitter')" v-if="twitter">
                        <div class="join-us-icon"><img src="/assets/img/logo-twitter.jpg"></div>
                        <div class="join-us-text">FOLLOW US ON TWITTER</div>
                    </a>
                </div>
            </div>
        </div>
        <div v-if="!seperateImageAndText" class="landing-page-image-container2 landing-page-image-additional" :style="topBannerStyle">
            <div class="landing-page-image-text-container" v-if="showCtaButton">
                <div class="landing-page-image-text" v-html="topBannerText">

                </div>
                <div class="landing-page-image-button" >

                    <a v-if="straightToWhatsapp" :href="whatsappLink ? whatsappLink : settings.socialLinks.whatsapp" class="button button-get-started" target="_blank">{{ctaButtonText}}</a>
                    <button v-if="!straightToWhatsapp" class="button button-get-started" @click="toggleJoinUs()">{{ctaButtonText}}</button>

                </div>
            </div>
        </div>
        <div v-if="seperateImageAndText" class="seperate-image-and-text">




            <div class="landing-page-image-container2 landing-page-image-additional" :style="topBannerStyle">

            </div>
            <div class="landing-page-slogan-container" v-if="showCtaButton">
                <div class="landing-page-slogan-text" v-html="topBannerText">

                </div>
                <div class="landing-page-slogan-button" >

                    <a v-if="straightToWhatsapp" :href="whatsappLink ? whatsappLink : settings.socialLinks.whatsapp" class="button button-get-started" target="_blank">{{ctaButtonText}}</a>
                    <button v-if="!straightToWhatsapp" class="button button-get-started" @click="toggleJoinUs()">{{ctaButtonText}}</button>

                </div>
            </div>
        </div>
        <div class="landing-page-how-it-works-container" v-if="showHowItWorks">
            <div class="landing-page-logo">
                <img :src="settings.logoUrl">
            </div>
            <div class="landing-page-how-it-works-text">
                How it Works
            </div>
            <div class="landing-page-boxes">
                <div class="landing-page-box">
                    <div class="landing-page-box-icon">1</div>
                    <div class="landing-page-box-title">{{howItWorks.one.title}}</div>
                    <div class="landing-page-box-text">{{howItWorks.one.text}}</div>
                </div>
                <div class="landing-page-box">
                    <div class="landing-page-box-icon">2</div>
                    <div class="landing-page-box-title">{{howItWorks.two.title}}</div>
                    <div class="landing-page-box-text">{{howItWorks.two.text}}</div>
                </div>
                <div class="landing-page-box">
                    <div class="landing-page-box-icon">3</div>
                    <div class="landing-page-box-title">{{howItWorks.three.title}}</div>
                    <div class="landing-page-box-text">{{howItWorks.three.text}}</div>
                </div>
            </div>
            <div class="landing-page-how-it-works-button">

                <a v-if="straightToWhatsapp" :href="whatsappLink ? whatsappLink : settings.socialLinks.whatsapp" class="button button-get-started" target="_blank">{{ctaButtonText}}</a>
                <button v-if="!straightToWhatsapp" class="button button-get-started" @click="toggleJoinUs()">{{ctaButtonText}}</button>

            </div>
        </div>
        <div class="landing-page-slogan-container">
            <div class="landing-page-slogan-text" v-html="bottomBannerText">

            </div>
            <div class="landing-page-slogan-button">
                <a v-if="straightToWhatsapp" :href="whatsappLink ? whatsappLink : settings.socialLinks.whatsapp" class="button button-get-started" target="_blank">{{ctaButtonText}}</a>
                <button v-if="!straightToWhatsapp" class="button button-get-started" @click="toggleJoinUs()">{{ctaButtonText}}</button>
            </div>
        </div>
        <div v-if="showDeals">
            <Deals showJoinUs="true" />
        </div>

        <div class="contact-us-info-container" v-if="settings.contactPhone || settings.contactEmail">
            <div class="title">Contact Us</div>
            <div class="info-wrapper">
                <div class="info-container" v-if="settings.contactEmail">
                    <div class="info-label">Email</div>
                    <div class="info-data">{{settings.contactEmail}}</div>
                </div>
                <div class="info-container" v-if="settings.contactPhone">
                    <div class="info-label">Phone</div>
                    <div class="info-data">{{settings.contactPhone}}</div>
                </div>
            </div>
        </div>

        <component :is="'style'">
            {{additionalStyle}}
        </component>
    </div>
</template>
<script>
    import settings from '@/settings'
    import ga from '@/helpers/ga'
    import clicky from '@/helpers/clicky'
    import Deals from '@/components/Deals.vue'
    export default {
        data() {
            return {
                showJoinUs: false,
                showBottomBanner: false,
                topBannerStyle: null,
                topBannerText: null,
                bottomBannerText: null,
                seperateImageAndText: false,
                straightToWhatsapp: false,
                whatsappLink: null,
                whatsapp: true,
                facebook: true,
                email: true,
                showDeals: false,
                twitter: true,
                instagram: true,
                additionalStyle: '',
                showCtaButton: true,
                showHowItWorks: true,
                howItWorks: {
                    one: {
                        title: 'Join the Fun',
                        text: 'Join us on your favorite social channel - WhatsApp, Facebook, or Instagram'
                    },
                    two: {
                        title: 'Receive Deals',
                        text: 'We find relevant deals and share them directly with you'
                    },
                    three: {
                        title: 'You Save',
                        text: 'Save valuable money on great family oriented products from all over the web'
                    }
                },
                ctaButtonText: 'Get Started',
                giveaway: null
            }
        },
        methods: {
            toggleJoinUs() {
                this.trackEvent('getstarted');

                if (this.giveaway) {
                    this.openNewsletterModal()
                }
                else {
                    this.showJoinUs = !this.showJoinUs;
                }

            },
            trackEvent: function (action) {
                ga.event(action, { 'event_category': 'landing', 'event_label': this.$route.params.landing, 'transport_type': 'beacon' });
                clicky.log(action, 'click')
            },
            openNewsletterModal() {
                this.$newsletter.show({ giveaway: this.giveaway })
            }
        },
        created() {
            switch (this.$route.params.landing) {

                case 'goldwater':
                    this.showBottomBanner = true;
                    this.topBannerStyle = `background-image: url('${settings.siteImageFolder + 'goldwater1.jpg'}'); `;
                    this.topBannerText = `Welcome Alyssa Goldwater followers!<br> It's time to meet MommyDeals!`;
                    this.bottomBannerText = `Being a mom is a full-time job.<br> MommyDeals is here to help!`;
                    this.additionalStyle = `.landing-page-image-additional { color: yellow }`;
                    break;
                case 'save':
                    this.showBottomBanner = true;
                    this.topBannerStyle = `background-image: url('${settings.siteImageFolder + 'baby1.jpg'}');
                                            height: 300px;
                                            background-size: contain;
                                            background-attachment: inherit;`;
                    this.topBannerText = `Ready to save money during quarantine?`;
                    this.bottomBannerText = `Being a mom is a full-time job.<br> MommyDeals is here to help!`;
                    this.additionalStyle = `.landing-page-image-additional { color: yellow }`;
                    this.seperateImageAndText = true;
                    break;
                case 'smartmom':
                    this.showBottomBanner = true;
                    this.topBannerStyle = `background-image: url('${settings.siteImageFolder + 'smartmom.jpg'}');
                                            background-position-y: 0;
                                            background-size: contain;
                                            background-attachment: inherit;
                                            height: 275px;
                                            `;
                    this.topBannerText = `This mom is using our WhatsApp group to save money!`;
                    this.bottomBannerText = `Being a mom is a full-time job.<br> MommyDeals is here to help!<br><br> Shop our Deals!`;
                    this.additionalStyle = `.landing-page-image-additional { color: yellow }`;
                    this.seperateImageAndText = false;
                    this.whatsapp = true;
                    this.facebook = false;
                    this.email = false;
                    this.twitter = false;
                    this.instagram = false;
                    this.straightToWhatsapp = true;
                    this.showDeals = true;
                    this.showCtaButton = false;
                    this.whatsappLink = '/JoinWhatsapp';
                    this.showHowItWorks = false;
                    //this.howItWorks = {
                    //    one: {
                    //        title: 'Join the Fun',
                    //        text: 'Join us on WhatsApp'
                    //    },
                    //    two: {
                    //        title: 'Receive Deals',
                    //        text: 'We find relevant deals and share them directly with you'
                    //    },
                    //    three: {
                    //        title: 'You Save',
                    //        text: 'Save valuable money on great family oriented products from all over the web'
                    //    }
                    //};
                    break;
                case 'giveaway500':
                    this.showBottomBanner = true;
                    this.topBannerStyle = `background-image: url('${settings.siteImageFolder + 'giveaway500.jpg'}'); `;
                    this.topBannerText = `Sign up for our $500 giveaway!`;
                    this.bottomBannerText = `Being a mom is a full-time job.<br> MommyDeals is here to help!`;
                    this.additionalStyle = `.landing-page-image-additional { color: yellow }`;
                    this.giveaway = 'giveaway500';
                    this.ctaButtonText = 'Sign Up';
                    this.howItWorks = {
                        one: {
                            title: 'Sign Up',
                            text: 'Signup by join our daily deals email blast.'
                        },
                        two: {
                            title: 'Get More Entries',
                            text: 'Share our giveaway with your friends to get more entries'
                        },
                        three: {
                            title: 'You Win',
                            text: 'You could win a $500 amazon giftcard'
                        }
                    };
                    break;
                default:
                    this.showBottomBanner = true;
                    this.topBannerStyle = `background-image: url('${settings.siteImageFolder + 'mom_running2.jpg'}');`;
                    this.topBannerText = 'Being a mom is a full-time job.<br> MommyDeals is here to help!';
                    this.bottomBannerText = 'Remember, you’re not <i>just</i> a Mom<br> You’re a Domestic Engineer!';
                    this.additionalStyle = ``;
                    break;
            }
        },
        computed: {
            settings: function () { return settings; },
        },
        components: {
            Deals
        }
    }
</script>

<style>
    
</style>